import { css } from '@emotion/css';
import { AccountStatusLabel } from 'src/models';
import { Font, Spacing } from 'src/styles';
import { getAccountStatusTagColor } from 'src/utils';

export const tag = (status: AccountStatusLabel) => {
  const schema = getAccountStatusTagColor(status);

  return css`
    border-radius: 0.5rem;
    font-weight: 600;
    ${Font.xs}
    ${Spacing.py4}
    ${Spacing.px8}
    border: 0.0625rem solid ${schema.background};
    color: ${schema.color};
    background-color: ${schema.background};
    height: 1.5rem;
    @media (max-width: 768px) {
      height: auto;
      min-height: 24px;
    }
  `;
};
